import { render, staticRenderFns } from "./customized.vue?vue&type=template&id=3946a34b&scoped=true"
import script from "./customized.vue?vue&type=script&lang=js"
export * from "./customized.vue?vue&type=script&lang=js"
import style0 from "./customized.vue?vue&type=style&index=0&id=3946a34b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3946a34b",
  null
  
)

export default component.exports